import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export const fncDeleteNotification = ({ commit, dispatch, state, rootState }, payload) => {
	var notificationDetails = {
		id: payload.id
	}
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'InternalNotifications.php?a=delete', notificationDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'The vendor could not be added, please try again', display: true };
			commit('setSnack', snackDetails);
		}).then(data => {
			if ( data == false ) {
				var snackDetails = { color: 'error', message: 'The notification could not be removed, please try again', display: true };
			} else {
				dispatch({
					type: 'fncGetStatusNotifications',
					id: payload.status,
					hideModal: true
				});
				var snackDetails = { color: 'success', message: 'The notification was removed successfully', display: true };
			}
			commit('setSnack', snackDetails);
			dispatch('fncPopulateStatusList');
			dispatch('fncPopulateStatusCount');
		});
};

export const fncSaveNotifications = ({ commit, dispatch, state, rootState }, payload) => {

	console.log('Payload');
	console.log( payload );

	for ( var p in payload.notifications ) {
		payload.notifications[p].roles = payload.notifications[p].roles.toString();
		if( payload.notifications[p].roles_ignore == null ) {
      payload.notifications[p].roles_ignore = 0;
    } else {
      payload.notifications[p].roles_ignore = payload.notifications[p].roles_ignore.toString();
    }

		payload.notifications[p].report_vendors = payload.notifications[p].report_vendors != null ? payload.notifications[p].report_vendors.toString() : '';
		payload.notifications[p].branches = payload.notifications[p].branches != null ? payload.notifications[p].branches.toString() : '';
		payload.notifications[p].direct = payload.notifications[p].direct != null ? payload.notifications[p].direct.toString() : '';
		payload.notifications[p].departments = payload.notifications[p].departments != null ? payload.notifications[p].departments.toString() : '';
		if( payload.notifications[p].vendors != undefined ) {
			payload.notifications[p].vendors = payload.notifications[p].vendors.toString();
		}
		payload.notifications[p].method = payload.notifications[p].method.toString();
		payload.notifications[p].notify_daily = payload.notifications[p].notify_daily == true ? 1 : 0;
		payload.notifications[p].notify_customer = payload.notifications[p].notify_customer == true ? 1 : 0;
		payload.notifications[p].notify_originator = payload.notifications[p].notify_originator == true ? 1 : 0;
		payload.notifications[p].notify_kam = payload.notifications[p].notify_kam == true ? 1 : 0;
		payload.notifications[p].notify_coordinator = payload.notifications[p].notify_coordinator == true ? 1 : 0;
	}

	var objAuth = JSON.parse(rootState.objAuthorize);
	var notificationDetails = {
		manufacturer: objAuth.manufacturer,
		status: payload.status,
		notifications: payload.notifications
	}
  let jsonData = JSON.stringify(notificationDetails);
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'InternalNotifications.php?a=update', jsonData, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'The vendor could not be added, please try again', display: true };
			commit('setSnack', snackDetails);
		}).then(data => {
			if ( data == false ) {
				var snackDetails = { color: 'error', message: 'The notifications could not be updated, please try again', display: true };
			} else {
				commit('fncEmptyStatusNotifications');
				setTimeout(function(){
					dispatch({
						type: 'fncGetStatusNotifications',
						id: payload.status,
						hideModal: true
					});
				}, 500)
				var snackDetails = { color: 'success', message: 'The notifications were updated successfully', display: true };
			}
			commit('setSnack', snackDetails);
			dispatch('fncPopulateStatusList');
			dispatch('fncPopulateStatusCount');
		});
};

export const fncGetStatusNotifications = ({ commit, dispatch, state, rootState }, payload) => {

	var objAuth = JSON.parse(rootState.objAuthorize);
	var statusDetails = { a: 'retrieve', manufacturer: objAuth.manufacturer, status: payload.id, subFilter: payload.subFilter, notification_types: payload.notification_types  };

	Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'InternalNotifications.php', { params: statusDetails }, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {

			commit('fncSetStatusNotifications', '');

			setTimeout(function(){
        commit('fncSetStatusNotifications', data);
      }, 1)

			if( payload.hideModal == null ) {
				var modalDetails = { title: payload.description, component: 'modal-set-notifications', mstate: true, params: { statusId: payload.id, statusName: payload.description, statusDepartment: payload.department } };
				commit({
					type: 'setModal',
					details: modalDetails
				});
			}
		});
};

export const fncPopulateStatusCount = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var statusDetails = { manufacturer: objAuth.manufacturer };
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'InternalNotifications.php?a=get_notification_count', statusDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {
			commit('fncPopulateStatusCount', data);
	});
};

export const fncSaveState = ({ commit, dispatch, state, rootState }, payload) => {
	var objAuth = JSON.parse(rootState.objAuthorize);
	var stateDetails = { id: payload.id, state: payload.newState };
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'InternalNotifications.php?a=save_state', stateDetails, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {
			if( data == true ) {
				var snackDetails = { color: 'success', message: 'The state was updated successfully', display: true };
				commit('setSnack', snackDetails);
			} else {
				var snackDetails = { color: 'error', message: 'There was an error updating the state', display: true };
				commit('setSnack', snackDetails);
			}

	});
};

export const getQuoteSendStatuses = ({ commit, dispatch, state, rootState }, payload) => {

  var stateDetails = { manufacturer: payload };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'InternalNotifications.php?a=getQuoteSendStatuses', stateDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

      commit('fncSetQuoteStatuses', data);

    /*if( data == true ) {
      var snackDetails = { color: 'success', message: 'The state was updated successfully', display: true };
      commit('setSnack', snackDetails);
    } else {
      var snackDetails = { color: 'error', message: 'There was an error updating the state', display: true };
      commit('setSnack', snackDetails);
    }*/

  });
};

export const fncPopulateWhatsappTemplates = ({ commit, dispatch, state, rootState }, payload) => {

  var stateDetails = { manufacturer: payload };
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Notification.php?a=retrieve_whatsapp_templates', stateDetails, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      console.log(error);
    }).then(data => {

      commit('fncSetWhatsappTemplates', data);

  });
};
